<p-card class="w-full">
  <p-steps
    [model]="items"
    [readonly]="true"
    class="w-full"
    [activeIndex]="currentStep$ | async"
  ></p-steps>
</p-card>
<router-outlet></router-outlet>
